import type {CohortPromoCodePerkIntegrationStruct} from '@cohort/shared/apps/cohort/perks/promoCode';
import {CohortPromoCodePerkIntegrationSpec} from '@cohort/shared/apps/cohort/perks/promoCode';
import {CohortPromoCodePerkUsageComponent} from '@cohort/wallet/apps/cohort/perkIntegrations/promoCode/PerkUsageComponent';
import type {PerkIntegration} from '@cohort/wallet/apps/PerkIntegration';

export const CohortPromoCodePerkIntegration: PerkIntegration<CohortPromoCodePerkIntegrationStruct> =
  {
    spec: CohortPromoCodePerkIntegrationSpec,
    usageComponent: CohortPromoCodePerkUsageComponent,
    usageType: 'embed',
  };
